import React from 'react'
import Box from './Box'
import Payment from '../Payment/Payment'
import StepHeading from './StepHeading'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import StepCopy from './StepCopy'
import { Link } from 'react-router-dom'
import { selectFirstName, selectIsLoggedIn } from '../../store/userSlice'
import { useSelector } from 'react-redux'
import { selectPricingConfig } from '../../store/pricingSlice'
import BillingText from '../BillingText/BillingText'

export type Scenario =
  | 'gympass'
  | 'partner'
  | 'renew'
  | 'upgrade'
  | 'signup'
  | 'voucher'
  | undefined

type Props = {
  onLogInClick: () => void
  onBack: () => void
  plan: {
    duration: 1 | 3 | 6 | 12 | 24
    price: number
    originalPrice: number
    discount: number
  }
  scenario: Scenario
  pricingConfig?: {
    currency: string
  }
  onChangePlan: () => void
}

function SignUpPayment({
  onLogInClick,
  onBack,
  plan,
  scenario,
  pricingConfig: pricingConfigFromProp,
  onChangePlan,
}: Props) {
  let pricingConfig = useSelector(selectPricingConfig())
  if (pricingConfigFromProp) pricingConfig = pricingConfigFromProp
  const isTrial = pricingConfig.trialDuration !== 0
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const name = useSelector(selectFirstName)

  return (
    <div className="o-width-limiter flex w-full flex-col">
      <div>
        <StepHeading>
          <FormattedMessage {...messages['upgrade.pay_heading']} />
        </StepHeading>
        {isLoggedIn && name && (
          <Link
            to="/account/"
            className="text-Type underline underline-offset-4 hover:text-TypeSub"
          >
            <h3 className="mb-24 text-center md:mb-32">
              <FormattedMessage {...messages.greeting} values={{ name }} />
            </h3>
          </Link>
        )}

        <StepCopy>
          <ul className="leading-body type-17">
            <li>
              <FormattedMessage {...messages.pay_your_subscription} />
              {': '}
              {plan.duration}{' '}
              {
                <FormattedMessage
                  {...messages[plan.duration === 1 ? 'month' : 'months']}
                />
              }
              {'. '}
              <button onClick={onChangePlan} className="underline">
                <FormattedMessage id="SignUp.change" />
              </button>
            </li>
            <li className="mt-8">
              <BillingText
                duration={plan.duration}
                price={plan.originalPrice || plan.price}
                currency={pricingConfig.currency}
              />
              .
            </li>
            {plan.discount > 0 && (
              <li className="leading-default type-14-demibold">
                <BillingText
                  duration={plan.duration}
                  discount={plan.discount}
                  discountOnlyFirstPurchase={
                    pricingConfig.discountOnlyFirstPurchase
                  }
                  price={plan.price}
                  originalPrice={plan.originalPrice}
                  currency={pricingConfig.currency}
                  roundDiscount={false}
                />
              </li>
            )}
            {isTrial && (
              <li className="leading-default type-14-demibold">
                <FormattedMessage
                  id="pickSubscription.daysFree"
                  defaultMessage="First {days} days free"
                  values={{ days: pricingConfig.trialDuration }}
                />
              </li>
            )}
            <li className="mt-8">
              <FormattedMessage {...messages.cancel} />
            </li>
          </ul>
        </StepCopy>
      </div>
      <Box onBack={onBack}>
        <Payment
          amount={plan.price}
          oldAmount={plan.discount ? plan.originalPrice : false}
          plan={plan.duration}
          scenario={scenario}
          onLogInClick={onLogInClick}
          pricingConfig={pricingConfig}
        />
      </Box>
    </div>
  )
}

export default SignUpPayment
